import { render, staticRenderFns } from "./CtTributacao.vue?vue&type=template&id=3459f6c6&"
import script from "./CtTributacao.vue?vue&type=script&lang=js&"
export * from "./CtTributacao.vue?vue&type=script&lang=js&"
import style0 from "./CtTributacao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports